class ChatWebSocketService {
  static instance = null;

  constructor() {
    this.socketRef = null;
    this.heartbeatInterval = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000; // 1 segundo inicial
    console.log('[WebSocket] Service initialized');
  }

  static getInstance() {
    if (!ChatWebSocketService.instance) {
      ChatWebSocketService.instance = new ChatWebSocketService();
    }
    return ChatWebSocketService.instance;
  }

  connect(roomId, accessToken, onMessage) {
    const wsBaseUrl = process.env.REACT_APP_WS_BASE_URL;
    const fullUrl = `${wsBaseUrl}/chat/${roomId}/?token=${accessToken}`;

    console.log("[WebSocket] Connecting to:", fullUrl);
    this.socketRef = new WebSocket(fullUrl);

    this.socketRef.onopen = () => {
      console.log('[WebSocket] Connected (onopen)');
      console.log('[WebSocket] readyState:', this.socketRef.readyState);
      this.reconnectAttempts = 0; // Resetear intentos de reconexión
      this.startHeartbeat();
    };

    this.socketRef.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        
        // Manejar mensajes de heartbeat
        if (data.type === 'heartbeat') {
          console.log('[WebSocket] Received heartbeat from server:', data.timestamp);
          this.handleHeartbeat(data);
          return;
        }
        
        if (data.type === 'heartbeat_ack') {
          console.log('[WebSocket] Received heartbeat acknowledgment:', data.timestamp);
          return;
        }

        console.log('[WebSocket] Message received:', data);
        onMessage(data);
      } catch (err) {
        console.error('[WebSocket] Failed to parse message:', err, event.data);
      }
    };

    this.socketRef.onclose = (event) => {
      console.warn('[WebSocket] Connection closed:', event);
      console.log('[WebSocket] readyState after close:', this.socketRef.readyState);
      console.log('[WebSocket] Close code:', event.code);
      console.log('[WebSocket] Close reason:', event.reason);
      this.stopHeartbeat();
      this.handleReconnect(roomId, accessToken, onMessage);
    };

    this.socketRef.onerror = (error) => {
      console.error('[WebSocket] Error:', error);
      console.log('[WebSocket] readyState on error:', this.socketRef.readyState);
    };

    // Monitor unexpected readyState transitions
    setTimeout(() => {
      if (this.socketRef.readyState !== WebSocket.OPEN) {
        console.warn('[WebSocket] Still not open after timeout. Current readyState:', this.socketRef.readyState);
      }
    }, 2000);
  }

  startHeartbeat() {
    // Limpiar intervalo existente si lo hay
    this.stopHeartbeat();
    
    console.log('[WebSocket] Starting heartbeat interval');
    // Enviar heartbeat cada 25 segundos (antes que el servidor)
    this.heartbeatInterval = setInterval(() => {
      if (this.socketRef && this.socketRef.readyState === WebSocket.OPEN) {
        const timestamp = new Date().toISOString();
        console.log('[WebSocket] Sending heartbeat:', timestamp);
        this.sendMessage({
          type: 'heartbeat',
          timestamp: timestamp
        });
      } else {
        console.warn('[WebSocket] Cannot send heartbeat - connection not open');
      }
    }, 25000);
  }

  stopHeartbeat() {
    if (this.heartbeatInterval) {
      console.log('[WebSocket] Stopping heartbeat interval');
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  }

  handleHeartbeat(data) {
    // Responder al heartbeat del servidor
    if (this.socketRef && this.socketRef.readyState === WebSocket.OPEN) {
      const timestamp = new Date().toISOString();
      console.log('[WebSocket] Responding to server heartbeat:', timestamp);
      this.sendMessage({
        type: 'heartbeat',
        timestamp: timestamp
      });
    } else {
      console.warn('[WebSocket] Cannot respond to heartbeat - connection not open');
    }
  }

  handleReconnect(roomId, accessToken, onMessage) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      const delay = this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1); // Exponential backoff
      
      console.log(`[WebSocket] Attempting to reconnect in ${delay}ms (attempt ${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
      
      setTimeout(() => {
        console.log('[WebSocket] Executing reconnection attempt', this.reconnectAttempts);
        this.connect(roomId, accessToken, onMessage);
      }, delay);
    } else {
      console.error('[WebSocket] Max reconnection attempts reached');
    }
  }

  sendMessage(data) {
    if (this.socketRef && this.socketRef.readyState === WebSocket.OPEN) {
      console.log('[WebSocket] Sending message:', data);
      this.socketRef.send(JSON.stringify(data));
    } else {
      console.error('[WebSocket] Cannot send message. Connection not open. Current readyState:', this.socketRef?.readyState);
    }
  }

  disconnect() {
    console.log('[WebSocket] Disconnect called');
    this.stopHeartbeat();
    if (this.socketRef) {
      this.socketRef.close();
      console.log('[WebSocket] Socket closed');
    }
  }
}

export default ChatWebSocketService.getInstance();